import { Component, Mixins, Prop } from 'vue-property-decorator';

import LayoutMixin from '@/mixins/LayoutMixin';

@Component({})
export default class TwoColumn extends Mixins(LayoutMixin) {
  @Prop()
  readonly IsAuthorized: Boolean;
}
